module.exports = __webpack_public_path__ + "img/steel-electric-products.5a77c1b8.png";